import { ledgerEndPoints } from "../constants/endpoints";
import { LedgerResponseType } from "../constants/types";
import { api } from "./api";

type UpdateType = {
  credit: string;
  orderId?: string;
  customerId: string;
  id?: string; // for update
};

// for both: create and update ledger
export const updateLedger = async (data: UpdateType) => {
  try {
    return await api.put(ledgerEndPoints.base, data);
  } catch (error) {
    throw new Error("Failed to create or update ledger");
  }
};

export const deleteLedger = async (id: string) => {
  try {
    return await api.delete(`${ledgerEndPoints.base}/${id}`);
  } catch (error) {
    throw new Error("Failed to delete ledger entry");
  }
};

export const getLedgerList = async (queryParams: Record<string, string>) => {
  try {
    const queryString = new URLSearchParams(queryParams).toString();
    const response = await api.get(`${ledgerEndPoints.base}?${queryString}`);
    return response.data.data.response as LedgerResponseType;
  } catch (error) {
    throw new Error("Failed to fetch ledger list");
  }
};

export const downloadLedger = async (data: Record<string, string>) => {
  try {
    const queryString = new URLSearchParams(data).toString();
    const response = await api.get(
      `${ledgerEndPoints.download}?${queryString}`
    );
    return response.data.data as LedgerResponseType;
  } catch (error) {
    throw new Error("Failed to download ledger");
  }
};
